export { default } from './core-menu-footer';
